import React from 'react';
import { TextField, NumericFormat, TextFieldProps } from '@qbe/ads-core';

const PrefixedTextField = (props: any) => {
  return <TextField prefix="$" {...props} />;
};

const CurrencyTextField = (props: any) => {
  return (
    <NumericFormat
      customInput={PrefixedTextField}
      thousandSeparator
      allowNegative={false}
      decimalScale={2}
      fixedDecimalScale={true}
      {...props}
      type="text" // required as NumericFormat `type` is more restrictive than TextField's
    />
  );
};

export default CurrencyTextField;
